import React, {useState,useEffect} from "react"
import { useRouteMatch, useHistory, useParams } from "react-router-dom";
import { rowPerPageDataArray,rowPerPageDataHome } from "../TextInputUtils";
import Table from "@mui/material/Table";
import { Typography } from '@mui/material';
import TableBody from "@mui/material/TableBody";
import TableCell,{ tableCellClasses }from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Switch from "@mui/material/Switch";
import Checkbox from '@mui/material/Checkbox';
// import { Link } from "@mui/material";
import { Link } from "react-router-dom/cjs/react-router-dom";



const CustomTable= (props)=> {
  
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [status,setStatus]=useState(1)
    const history = useHistory();
    const columns = props?.columnHeader
    const [countPerPage,setCountPerPage]=useState()
    const label = { inputProps: { "aria-label": "Switch demo" } };
    const firstTitle = "Please note to make a change for the year 2027, 2028 and 2029, changes has to be done in the year 2029 as the data is shown in one single box on the website for all these years."
    const secondTiltle = "Please note to make a change for the year 2030, 2031 and 2032, changes has to be done in the year 2030 as the data is shown in one single box on the website for all these years." 

    const initializeSwitchValues = (data) => {
      return data.map((data) => data?.status || data?.is_active === 1 ? true : false);
  };
    const [switchValue,setSwitchValue]=useState([]);
    const minTableWidth = props?.from !== undefined ? "140%" : "100%"
      // useEffect(() => {
      //   if(props?.revertStatus ){
          
      //     const initializedValues = initializeSwitchValues(props.data);
      //     setSwitchValue(initializedValues)
      //   }
      //  }, [props?.revertStatus,switchValue.length]);

    useEffect(() => {
     if(props?.data.length > 0){
      setSwitchValue(initializeSwitchValues(props.data))
      setPage(0)
      setRowsPerPage( props?.from === 'Master data' ? 11:10)
     }
    }, [props?.data.length]);

    const handleChangePage = (event, newPage) => {
      setPage(newPage);
    };
  
    const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(event.target.value);
      setPage(0);
    };

        //function to hanlde switch 
  const handleSwitch = (e,position,data) => {
    const updatedSwitchValue = [...switchValue];
  // Update the value of the switch at the specified index
     updatedSwitchValue[position] = e;
    setSwitchValue(updatedSwitchValue)
    props.openStoreDisable( e ? 1 : 0,data) 
   
  }

  const  formatDate = (dateString) => {
   const date = new Date(dateString); // Parse the date string into a Date object
    
    // Extract date parts and format them
    const day = String(date.getUTCDate()).padStart(2, '0');
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const year = date.getUTCFullYear();
    
    // Return formatted date string
    return `${day}-${month}-${year}`;
}

  //function to handle truncate text
  const truncateText = (text, maxLength) => {
    return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
  };

  const handleOrderView = (data) => {
    props.onClickAction(data)
  }

  const handleViewEnquire = (data) => {
    props.onclickView(data)
  }

  //function to handle dynamic edit 
  const handleDynamicEdit = (data) => {
    props.onClickAction(data)
  }

   //function to handle dynamic edit 
   const handleHomeDataEdit = (data) => {
    props.onClickAction(data)
  }

  //function to handle timeline edit 
  const handleTimeLineEdit = (data) => {
   props.onClickAction(data)
  }


  //function call to handle seo data edit
  const handleSeoDataEdit = (data) => {
    props?.onClickSeoOpen(data)
  }
  const handleChange = (event,data) => {
    const isChecked = event.target.checked;
    props?.checkedReport(isChecked,data)
  };
  

  let count = props?.data.length ;
  const total_records = count <= 0 || count === countPerPage ? "00" : count;
    const rows = props?.data?.map((data,index) => ({
    
      id: <div key={index}>{index+1}</div>,
      first_name: (
        props?.path && data?.name !== null?
        <Link to ={ {     
          pathname: props?.path,
          state:{info : data,
          }
         } }
         class="primaryColor"
         >
        {data?.name !== null ? data?.name : "-"}
        </Link>
        :
        <h6 class="text-start mx-2">{data?.name !== null ? data?.name : "-"}</h6>
      ),
      Store_name : (
        props?.path  ?
        <Link to ={ {     
          pathname: props?.path,
          state:{info : data,
          }
         } }
         class="primaryColor"
         >
          {data?.name === '' ?   "-"  :  data?.name}
        </Link>
        //  data?.name
        :
        <h6 class="m-0 fs-6">{data?.name}</h6>
      ) ,
      name :(
        props?.path  ?
        <Link to ={ {     
          pathname: props?.path,
          state:{info : data,
          }
         } }
         class="primaryColor"
         >
          {data?.name}
        </Link>
        :
        <h6 class={ props?.from === "orderRequest" ? "previewColor cursorPointer fw-normal m-0" : " fw-normal m-0"} onClick={() => props?.from === "orderRequest" ?  handleOrderView(data) : null} >{data?.name}</h6>
      ) ,
      Store_Category : data?.service_name === undefined || data?.service_name === '' ? <div class="text-start" ><h6> {"-"}</h6> </div> : data?.service_name,
      phone_number : (data?.phone_number === undefined || data?.phone_number === "" )&& data?.mobile === undefined   ? <div class="text-start" ><h6> {"-"}</h6> </div>: data?.mobile || data?.phone_number,
      share_count : data?.sell_shares !== 0 ? data?.sell_shares : 0,
      share_amount : data?.buy_amount !== 0 ? data?.buy_amount : 0,
      Share_Value : <h6>₹{data?.value !== 0 ? data?.value : 0}/-</h6>,//need to change when implementaing the api acordingly
      service :data?.service,
      amount_invested: <h6 class="fw-normal m-0" >₹{ (data?.amount_invested === 0 || data?.amount_invested === null) ? 0 :`₹${data?.amount_invested}`}</h6>,
      order_message : data?.message !== undefined ? truncateText(data?.message, 20) : null ,
      order_status:  data?.approved !== null ?  <i class={`fa-solid fa-circle-check fa-2x m-2`} style={{ color: '#05B84D' }}  aria-hidden="true"></i>   : (data?.approved === null && data?.cancel_by === null) ? <i class={`fa-solid fa-circle-check fa-2x m-2`} style={{ color: '#989898' }} aria-hidden="true"></i>: <i class="fa-solid fa-circle-xmark fa-2x m-2"  style={{ color: 'red' }} aria-hidden="true"></i>  ,
      email: data?.email === undefined ||  data?.email === "" || data?.email === null  ? <div class="text-start" ><h6> {"-"}</h6> </div> : truncateText(data?.email, 27) ,
      city:  data?.city_name === null ? <div class="text-start" ><h6> {"-"}</h6> </div> : data?.city_name,
      user_city: data?.city === null ? <div class="text-start" ><h6> {"-"}</h6> </div> : data?.city,
      state : data?.state !== undefined ? data?.state : "-",
      user_name:(
        props?.path?.UserDepetailsPath && data?.user_name !== null?
        <Link to ={ {     
          pathname: props?.path?.UserDepetailsPath,
          state:{info : data,
          }
         } }
         class="primaryColor"
         >
        {data?.user_name !== null ? data?.user_name : "-"}
        </Link>
        :
        <h6 class="text-start mx-2">{data?.user_name !== null ? data?.user_name : "-"}</h6>
      ),
      bank_details:data?.bank_details !== null ? data?.bank_details : "-",
      demat_account:data?.demat_account !== undefined && data?.demat_account !== "" ? data?.demat_account : "-",
      account_created_date:data?.account_created_date !== undefined ? data?.account_created_date:"-",
      investment_type:data?.investment_type !== undefined ? data?.investment_type :"-",
      transaction_type:data?.transaction_type !== undefined ? <div className="text-center">{data?.transaction_type }</div> : "-",
      approved_date:data?.approved_date !== null ?  formatDate(data?.approved_date) : "-",
      no_of_shares:data?.no_of_shares !== undefined ? data?.no_of_shares :"-",
      current_share_value: data?.current_share_value !== null ? data?.current_share_value : "-",
      current_shares:data?.current_shares !== null ? data?.current_shares : "-",
      share_amount:data?.amount !== undefined ? `₹${data?.amount}` : "-",
      transaction_date:data?.transaction_date !== undefined ? formatDate(data?.transaction_date) : "-",
      pageName:data?.url,
      title:data?.title,
      masterData_store_name:data?.name,
      expected_to_reach:data?.expected_reach,
      sub_heading:data?.sub_heading,
      id_checked:<div><Checkbox  onChange={(event) => handleChange(event,data)} /></div>,
      description:data?.description,
      keywords:data?.keywords,
      lat:data?.lat,
      lng:data?.lng,
      branch:data?.branch,
      address:data?.address !== undefined ?truncateText(data?.address, 27) : "-",
      key : data?.key,
      value :  <div class="d-flex "><h6 class=" m-0" style={data?.key === "SHARE_DISTRIBUTION" ? {height:"30px",overflowY:"scroll"} : null}  >{data?.value}</h6></div> ,
      year : data?.year,
      timeLineEdit : <div 
       class="flex flex-row"> 
       <i class="bi bi-pencil-fill cursorPointer mx-2"  onClick={ () =>  handleTimeLineEdit(data)}></i>
       {(data?.year === "2027, 2028" || data?.year=="2031, 2032")  ?
        <span data-bs-toggle="tooltip" data-bs-placement="top" title={data?.year === "2027, 2028" ? firstTitle : secondTiltle} class="ms-3" ><i class="bi bi-exclamation-circle cursorPointer"></i></span> : 
        null
       }
        </div>,
      dynamicEdit : <div data-bs-toggle="tooltip" data-bs-placement="top" class="flex flex-row"> <i class="bi bi-pencil-fill cursorPointer mx-2"   onClick={ () => handleDynamicEdit(data)}></i><span data-bs-toggle="tooltip" data-bs-placement="top" title={data?.description} class="mx-3" ><i class="bi bi-exclamation-circle cursorPointer"></i></span></div>,
      homeDataEdit : <div   class="flex flex-row"> <i class="bi bi-pencil-fill cursorPointer mx-2"   onClick={ () => handleHomeDataEdit(data)}></i></div>,
      seoEdit: <div class="flex flex-row text-center"> <i class="bi bi-pencil-fill cursorPointer" onClick={() => handleSeoDataEdit(data)}></i> </div>,
      details : <div> <h6 class="previewColor cursorPointer m-0" onClick={() => handleViewEnquire(data)}>View</h6> </div>,
      is_active:  <div class="d-flex w-25 justify-content-center align-items-center border-0">
      <Switch
         {...label}
         value={switchValue[index]}
         onClick={(e) => {
           handleSwitch(e?.target?.checked,index)
            e.target.checked ? setStatus(1) : setStatus(0)
            props.onStausChange( e.target.checked ? 1 : 0,data) 
         }}
          checked={switchValue[index]}
          disabled={true}
       />
     </div>,
      is_activeStore:  <div class="d-flex w-25 justify-content-center align-items-center border-0">
      <Switch
         {...label}
         key={index}
         value={switchValue[index]}
         onClick={(e) => {
            handleSwitch(e?.target?.checked,index,data)
         }}
          checked={ data?.is_active === 1 ? true : false}
          disabled={data.is_published === 0 ? true : false}
        //  defaultChecked
       />
     </div>,
     is_activeShare:  <div class="d-flex w-25 justify-content-center align-items-center border-0">
     <Switch
        {...label}
        key={index}
        value={switchValue[index]}
        onClick={(e) => {
           handleSwitch(e?.target?.checked,index,data)
        }}
         checked={data?.is_active === 1 ? true : false}
         disabled={data.is_published === 0 ? true : false}
       //  defaultChecked
      />
    </div>
    }));

    return (
      <div  
       class="d-flex flex-column px-4"
      >
        <div >
        <TableContainer
     style={{ maxHeight: '67vh',  overflowY: 'auto',overflowX: 'auto'  }}
         >
          <Table stickyHeader size="small" aria-label="a dense table"  style={{
              minWidth:props.from === "share reports" ? '290%' : '100%', // Ensures table width adjusts to content
              width: '100%' // Ensures table container uses full width
            }} >
            <TableHead  >
              <TableRow >
                {columns.map((column) => (              
                  <TableCell
                    key={column.dataKey}
                    align={column.align}
                    // class="bg-tableHeaderColor"
                     style={{height:"20px",color:"black",padding:"5px",backgroundColor:"#D0DAFF",fontWeight:"bold",fontFamily:"Roboto-regular", width:column?.width}}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {rows
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row,index) => {
                  return (
                    <TableRow 
                    style={index % 2 === 0 ? {backgroundColor:"#FFFFFF"} : {backgroundColor:"#F3F9FF"}}   hover role="checkbox" tabIndex={-1} key={index}>
                      {columns.map((column) => {
                        const value = row[column.dataKey];
                        return (
                          <TableCell key={column.dataKey} align={column.align} style={{padding:"0px",paddingLeft:"5px"}}  height={35} >
                            {column.render ? column.render(value) : value}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
        <div class="d-flex flex-row justify-content-between">
         {
          props?.from === "homeData" ?
          null :
          <>
           <div class="d-flex  justify-content-center align-items-center">
            <h5 class="fw-normal">Total Records :{total_records}</h5>
          </div>
          <TablePagination
            rowsPerPageOptions={props?.from === "Master data" ? rowPerPageDataHome : rowPerPageDataArray}
            component="div"
            count={rows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            labelRowsPerPage={
              <Typography variant="body2" style={{ marginTop:"10px" }}>
                Rows per page:
              </Typography>
            }
            labelDisplayedRows={({ from, to, count }) => {
              return (
                <div style={{ marginTop: '10px' }}>
                  {`${from}-${to} of ${count}`}
                </div>
              );
            }}
      
          />
          </>
         }
          
        </div>
        </div>
      </div>
    );
  }
  
  export default CustomTable;